import { FIREBASE_CONFIG } from './config';

let dbRef: any;
export function setDbRef(ref: any) {
  dbRef = ref;
}

export default () => {
  if (!dbRef) {
    const firebase = require('firebase/app');
    require('firebase/database');
    firebase.initializeApp(FIREBASE_CONFIG);
    dbRef = firebase.database().ref();
  }

  return dbRef;
};

export async function fetch(func: () => Promise<any>) {
  // TODO: Think about this require
  let appStore: any;
  let t: any;
  // TODO: move to some kind of function
  if ((global as any).ENV !== 'backend') {
    appStore = require('../stores/app').default;
    ({ t } = require('../utils/appUtils'));
    appStore.toggleSmallLoading(true);
  }
  let result: any;
  try {
    result = await func();
  } catch (e) {
    if ((global as any).ENV !== 'backend') {
      appStore.showMessage({
        text: t('somethingWrongError'),
        type: 'error',
      });
      console.error(e);
    }
  }
  if ((global as any).ENV !== 'backend') appStore.toggleSmallLoading(false);
  return result.val ? result.val() : result;
}
